import { pxToRem } from '../../../../utils';
var treeStyles = {
  root: function root() {
    return {
      display: 'block',
      paddingLeft: "" + pxToRem(10)
    };
  }
};
export default treeStyles;
//# sourceMappingURL=treeStyles.js.map
